"use client"

/** Shared run CTA for intro + populated toolbar. Storybook: Catalog → Search → Analysis run button. */
import { Button } from '@yeshuman/sdk'
import { ChartNoAxesColumn, RefreshCw } from 'lucide-react'

export type SmartAnalysisRunButtonProps = {
  onClick: () => void
  isSearching: boolean
  disabled?: boolean
  className?: string
  label?: string
  runningLabel?: string
}

export function SmartAnalysisRunButton({
  onClick,
  isSearching,
  disabled = false,
  className,
  label = 'Run Analysis',
  runningLabel = 'Searching…',
}: SmartAnalysisRunButtonProps) {
  return (
    <Button
      type="button"
      size="sm"
      onClick={onClick}
      disabled={disabled || isSearching}
      className={className}
    >
      {isSearching ? (
        <>
          <RefreshCw className="animate-spin" aria-hidden />
          {runningLabel}
        </>
      ) : (
        <>
          <ChartNoAxesColumn aria-hidden />
          {label}
        </>
      )}
    </Button>
  )
}
